<template>
  <div class="management-page">
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getAll"
    ></Create>
    <Edit
      :editDialog="editDialog"
      @close="editDialog = false"
      @submit="getAll"
      :editDepartment="selectedDepartment"
    ></Edit>
    <v-progress-linear v-if="loading" indeterminate></v-progress-linear>

    <v-container class="management-container">
      <header class="management-header">
        <div>
          <small>Team organization</small>
          <h1>Departments</h1>
          <p>Group employees so schedules and time records stay organized.</p>
        </div>
        <v-btn rounded color="primary" @click="createDepartment">
          <v-icon left>mdi-plus</v-icon>New department
        </v-btn>
      </header>
      <div class="management-toolbar">
        <v-text-field v-model="search" outlined dense hide-details clearable
          prepend-inner-icon="mdi-magnify" placeholder="Search departments"></v-text-field>
        <span>{{ count }} {{ count === 1 ? "department" : "departments" }}</span>
      </div>
      <v-list v-if="departments.length" class="department-list">
        <template v-for="(item, index) in departments">
          <v-list-item :key="index" class="department-row">
            <v-list-item-avatar class="department-row__icon">
              <v-icon>mdi-account-group-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="item.name" class="text-capitalize font-weight-bold"></v-list-item-title>
              <v-list-item-subtitle>Employee department</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-menu offset-y bottom left content-class="management-action-menu">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list class="management-menu-list">
                  <v-list-item @click.stop.prevent="editDepartment(item)">
                    <v-list-item-icon><v-icon>mdi-pencil-outline</v-icon></v-list-item-icon>
                    <v-list-item-title>Edit department</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click.stop.prevent="deleteDepartment(item)">
                    <v-list-item-icon><v-icon color="error">mdi-delete-outline</v-icon></v-list-item-icon>
                    <v-list-item-title class="error--text">Delete department</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-action>
          </v-list-item>

        </template>
      </v-list>
      <div v-else-if="!loading" class="management-empty">
        <span><v-icon>mdi-account-group-outline</v-icon></span>
        <h2>{{ search ? "No departments found" : "Create your first department" }}</h2>
        <p>{{ search ? "Try a different search term." : "Departments help organize employees on the time clock and in reports." }}</p>
        <v-btn v-if="!search" color="primary" rounded @click="createDepartment">
          <v-icon left>mdi-plus</v-icon>Add department
        </v-btn>
        <v-btn v-else text color="primary" @click="search = ''">Clear search</v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import departmentService from "../service";
import "vue-swipe-actions/dist/vue-swipe-actions.css";
const Create = () => import("./Create");
const Edit = () => import("./Edit");

export default {
  name: "department-list",
  data() {
    return {
      search: null,
      departments: [],
      createDialog: false,
      editDialog: false,
      selectedDepartment: null,
      count: 0,
      limit: 50,
      offset: 0,
      loading: false,
      rowsPerPageItems: [10, 25, 50, 100],
      pagination: {
        rowsPerPage: 10,
        sortBy: "name",
      },
    };
  },
  async created() {
    this.getAll();
  },
  watch: {
    search() {
      if (!this.search || this.search.length > 2) {
        this.getAll();
      }
    },
  },
  components: {
    Create,
    Edit,
  },
  methods: {
    createDepartment() {
      this.createDialog = !this.createDialog;
    },
    getAll() {
      this.loading = true;
      return departmentService
        .getAll(
          {
            limit: this.limit,
            offset: this.offset,
            noPagination: true,
            search: this.search,
            orderBy: [this.pagination.sortBy],
          },
        )
        .then(async (response) => {
          const departments = response.data;
          this.departments = departments.sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          });
          this.count = response.count;
          this.loading = false;
          return response;
        })
        .catch((error) => {
          this.loading = false;
          throw error;
        });
    },
    deleteDepartment(department) {
      return this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then((result) => {
          if (result.isConfirmed) {
            departmentService.delete(department.id).then((response) => {
              if (response.data) {
                this.$toast.success("Department has been deleted", {
                  timeout: 2000,
                });

                this.getAll();
              }
            });
          }
        })
        .catch((error) => {
          this.$toast.error(error.data ? error.data.message : "Error", {
            timeout: 2000,
          });
        });
    },
    editDepartment(department) {
      if (department) {
        this.selectedDepartment = department;
        this.editDialog = !this.editDialog;
      } else {
        return alert("Id Not Found");
      }
    },
  },
};
</script>

<style scoped>
.management-page {
  color: var(--v-textPrimary-base);
}

.management-container {
  height: calc(100vh - 132px);
  max-width: 980px;
  overflow: auto;
  padding: 24px 20px 100px;
}

.management-header,
.management-toolbar {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.management-header {
  gap: 16px;
  margin-bottom: 18px;
}

.management-header small {
  color: var(--v-textSecondary-base);
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.management-header h1 {
  font-size: 1.7rem;
  margin: 1px 0 3px;
}

.management-header p {
  color: var(--v-textSecondary-base);
  font-size: 0.78rem;
  margin: 0;
}

.management-toolbar {
  background: var(--v-surface-base);
  border: 1px solid var(--v-border-base);
  border-radius: 15px;
  gap: 14px;
  margin-bottom: 12px;
  padding: 10px;
}

.management-toolbar ::v-deep .v-input__slot {
  background: var(--v-surfaceMuted-base) !important;
}

.management-toolbar > span {
  color: var(--v-textSecondary-base);
  flex: 0 0 auto;
  font-size: 0.72rem;
  font-weight: 700;
  padding-right: 8px;
}

.department-list {
  background: transparent !important;
  padding: 0;
}

.department-row {
  background: var(--v-surface-base);
  border: 1px solid var(--v-border-base);
  border-radius: 14px;
  margin-bottom: 9px;
  min-height: 76px;
}

.department-row__icon {
  background: rgba(96, 165, 250, 0.12);
  border-radius: 11px !important;
}

.department-row__icon .v-icon {
  color: var(--v-primary-base);
}

.management-empty {
  align-items: center;
  background: var(--v-surface-base);
  border: 1px dashed var(--v-border-base);
  border-radius: 18px;
  display: flex;
  flex-direction: column;
  min-height: 300px;
  padding: 48px 20px;
  text-align: center;
}

.management-empty > span {
  align-items: center;
  background: var(--v-surfaceMuted-base);
  border-radius: 17px;
  display: flex;
  height: 60px;
  justify-content: center;
  margin-bottom: 14px;
  width: 60px;
}

.management-empty .v-icon {
  color: var(--v-primary-base);
  font-size: 30px;
}

.management-empty h2 {
  font-size: 1.15rem;
}

.management-empty p {
  color: var(--v-textSecondary-base);
  font-size: 0.78rem;
  margin: 5px auto 18px;
  max-width: 380px;
}

@media (max-width: 600px) {
  .management-container {
    height: calc(100vh - 122px);
    padding: 16px 12px 90px;
  }

  .management-header {
    align-items: flex-start;
  }

  .management-header h1 {
    font-size: 1.35rem;
  }

  .management-header p {
    display: none;
  }

  .management-header .v-btn {
    min-width: 44px !important;
    padding: 0 12px !important;
  }

  .management-toolbar > span {
    display: none;
  }
}
</style>
